import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as actions from '../../actions';
import { Steps } from '../intro.js-react';
import Block from '../Misc/Block.js';


class Guide extends Component {
  constructor(props){
    super(props);

    this.props.breakLines(this.props.data.blockBreaks);
    this.state = {
      render : false
    }

    this.defaultOptions = {
      exitOnOverlayClick: false,
      hideNext: true,
      showStepNumbers: false,
      tooltipClass: "guide-tooltip",
      tooltipPosition: "right"
    }
  }

  componentDidMount(){
    this.setState({render: true});
  }

  onComplete(){
    //move to next lesson
    this.props.completeLesson(true);
  }

  onAfterChange(nextStepIndex, nextElement){
    //Add delay if exists
    const { buttonDelay } = this.props.data;

    if(!buttonDelay)
      return

    const buttons = document.querySelectorAll('.introjs-button');
    buttons.forEach((button) => {
      button.classList.add('introjs-disabled');
    });

    setTimeout(() => {
      buttons.forEach((button) => {
        button.classList.remove('introjs-disabled');
      });
    }, 1500);
  }

  getSteps(){
    const options = Object.assign(this.defaultOptions, this.props.data.options);
    if(this.state.render)
      return (
        <Steps
          enabled = {this.props.guide.enabled}
          autoStart = {true}
          steps = {this.props.data.steps}
          initialStep = {0}
          onExit = {() => this.props.disableGuide()}
          onAfterChange = {() => this.onAfterChange()}
          options = {options}
          introContainer = '#course-inner'
          onComplete = {() => this.onComplete()}
        />
      )
  }

  renderBlocks(){
    if(this.props.guide.blocks === undefined)
      return null;

    const {blocks, offsets} = this.props.guide.blocks;

    return blocks.map((block, index) => {
      let offset = offsets ? offsets[index] : false;

      return (
        <Block
          key = {'block' + index}
          block = {index+1}
          className = 'poem block'
          lines={block}
          offset={offset}
        />
      );
    });
  }

  render(){
    return (
      <div id="Guide">
        {this.getSteps()}
        <h2 className="title">{this.props.text.title}</h2>
        {this.renderBlocks()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    course: state.course,
    guide: state.guide,
    text: state.course.text
  };
}

export default connect(mapStateToProps, actions)(withRouter(Guide));



// WEBPACK FOOTER //
// ./src/components/Guide/Guide.js